<template>
    <div id="html" class="articleViewer">
        <p v-html="safeSurveyDesc" v-linkified:options="linkifiedOptions"/>
        <template v-for="image in images">
            <div class="imageContainer" @click="onClickPreviewImage({index: image.index})">
                <div>
                    <img :src="image.url" alt="">
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import linkify from 'vue-linkify';
    import {getSafeHtml} from '@/common/utils/safeHtml.js';
    import {htmlEntitiesDecode} from '@/common/utils/htmlEntities.js';
    import {getWebviewUrl} from '@common/utils/webview';

    export default {
        name: "ResponseDescText",
        directives: {
            linkified: linkify
        },

        props: {
            surveyDesc: {
                type: String,
                required: true,
            },

            images: {
                type: Array,
            },

            isWebview: {
                type: Boolean,
                required: true,
            },
        },

        computed: {
            safeSurveyDesc() {
                return getSafeHtml(this.surveyDesc);
            },

            linkifiedOptions() {
                return {
                    nl2br: true,
                    formatHref: (href, type) => {
                        // decode html entity
                        href = htmlEntitiesDecode(href);

                        if (this.isWebview) {
                            return getWebviewUrl({
                                url: encodeURIComponent(href),
                                landingtype: '2',
                                webviewtype: '1',
                            });
                        }

                        return href;
                    },
                    target: () => {
                        if (this.isWebview) {
                            return null;
                        }

                        return '_blank';
                    },
                    validate: {
                        url: function (value) {
                            return /^https?:\/\//.test(value);
                        }
                    }
                };
            },
        },

        methods: {
            onClickPreviewImage({index}) {
                this.$eventBus.$emit('clickPreviewImage', {index});
            },
        }
    }
</script>

<style scoped>

</style>
